var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as UserActions from '@ibe/store/actions/user.actions';
import { Router } from '@angular/router';
var INDRAConfirmDialogComponent = /** @class */ (function (_super) {
    __extends(INDRAConfirmDialogComponent, _super);
    function INDRAConfirmDialogComponent(store, router, _ConfirmDialogService) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.router = router;
        _this._ConfirmDialogService = _ConfirmDialogService;
        _this.isAlive = true;
        _this.htmlElement = document.getElementsByTagName('html');
        _this.ariaLabel = null;
        _this.overlay = false;
        _this.lockScroll = false;
        _this.isLoading = false;
        _this.onClose = new EventEmitter();
        return _this;
    }
    INDRAConfirmDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._ConfirmDialogService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isOpen = value;
            if (_this.lockScroll) {
                if (_this.isOpen) {
                    _this.htmlElement[0].classList.add('no-scroll');
                }
                else {
                    _this.htmlElement[0].classList.remove('no-scroll');
                }
            }
        }, function (error) { return console.error(error); }, function () { });
        if (this.isOpen === true) {
            if (this.router.url.indexOf('/flights') > 0)
                this.store.dispatch(new UserActions.PutConfirmDialogAction(true));
        }
    };
    INDRAConfirmDialogComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        this.store.dispatch(new UserActions.PutConfirmDialogAction(false));
        if (this.lockScroll) {
            this.htmlElement[0].classList.remove('no-scroll');
        }
    };
    INDRAConfirmDialogComponent.prototype.closeDialog = function () {
        this.onClose.emit();
        this._ConfirmDialogService.closeConfirmDialog();
        if (this.lockScroll) {
            this.htmlElement[0].classList.remove('no-scroll');
        }
    };
    return INDRAConfirmDialogComponent;
}(ConfirmDialogComponent));
export { INDRAConfirmDialogComponent };
